import { ErrorComponent } from './components/utils/errors/ErrorComponent';
import React, { useEffect, useState } from 'react';

const ErrorBoundary = ({ children }:{children: any}) => {
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      setError(new Error(event.message));
    };

    const handlePromiseRejection = (event: PromiseRejectionEvent) => {
      setError(new Error(event.reason));
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handlePromiseRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handlePromiseRejection);
    };
  }, []);

 

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
       <ErrorComponent 
       ctaButton={{}}
       />
      </div>
    );
  }

  return <>{children}</>;
};

export default ErrorBoundary;
